import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { PageNotFoundComponent } from '../../components/page-not-found/page-not-found.component';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { AdminGuard } from '../../shared/admin.guard';
import { AuthGuard } from '../../shared/auth.guard';
import { NoAccessPage } from './organization-settings/no-access.page';
import { OrganizationSettingsPage } from './organization-settings/organization-settings.page';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.ORGANIZATION_PROFILE}`, pathMatch: 'full' },
            {
                path: `${Paths.ORGANIZATION_SETTINGS}`,
                component: OrganizationSettingsPage,
                loadChildren: () =>
                    import('./organization-settings/organization-settings.module').then(
                        (m) => m.OrganizationSettingsModule,
                    ),
                canActivate: [AdminGuard],
                data: {
                    label: RouteLabels.TEXT_SNIPPETS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.ORGANIZATION_SETTINGS_NO_ACCESS}`,
                component: NoAccessPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.TEXT_SNIPPETS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            { path: '**', component: PageNotFoundComponent },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class OrganizationModule {}
